import { PermsContextType } from 'contexts/perms.types';
import React from 'react';
import { FaChevronDown, FaChevronUp, FaLock } from 'react-icons/fa6';

interface Props {
  roleId: number | string;
  perms: PermsContextType;
  hierarchy: Record<string, number>;
  yourHighestRoleHierarchyId?: number | null;
  onMoveUp?: (roleId: number | string) => void;
  onMoveDown?: (roleId: number | string) => void;
}

export default function RoleHierarchyCell({
  roleId,
  perms,
  hierarchy,
  yourHighestRoleHierarchyId,
  onMoveUp,
  onMoveDown,
}: Props) {
  const rank = hierarchy[String(roleId)];

  const roleIdNum = Number(roleId);
  const accessLevelNum = Number(perms.accessLevel ?? -1);

  const canEdit = (roleIdNum >= 0 && accessLevelNum >= 12) || accessLevelNum === 8;

  return (
    <div className="d-flex flex-row gap-1 justify-content-start align-items-center text-white">
      {canEdit ? (
        <div
          style={{
            width: 50,
          }}
        >
          <div className="d-flex flex-column align-items-center justify-content-center">
            {rank > 0 && (
              <div
                onClick={() => {
                  onMoveUp?.(roleId);
                }}
              >
                <FaChevronUp />
              </div>
            )}
            {rank >= 0 ? <div>{(rank ?? 0) + 1}</div> : <div />}
            {rank < Object.keys(hierarchy).length - 1 && (
              <div
                onClick={() => {
                  onMoveDown?.(roleId);
                }}
              >
                <FaChevronDown />
              </div>
            )}
          </div>
        </div>
      ) : (
        <div
          className="d-flex justify-content-center opacity-50"
          style={{
            width: 50,
          }}
        >
          {accessLevelNum === 10 &&
          roleIdNum !== -2 &&
          (hierarchy[String(roleId)] ?? -1) > (yourHighestRoleHierarchyId ?? -1) ? (
            <div />
          ) : (
            <FaLock />
          )}
        </div>
      )}
    </div>
  );
}
